(function($){

	OH.settings.datepickerControl = (function(){
		var define = new Object();
		
		var datesRange = function(to){
			var array = new Array();
			for(var i=0; i<to; i++){
				array.push(i+1);
			}
			return array;
		};
		var emptyRange = function(length){
			var array = new Array();
			for(var i=0; i<length; i++){
				array.push("");
			}
			return array;
		};
		
		
		if(sheet = OH.dynamicCSS.register("datepickerCSS", true)){
			sheet.addRule(".c-datepicker__main__pad{ text-align : center; }");
			sheet.addRule(".c-datepicker__main__pad > .c-datepicker__main{ display:inline-block; vertical-align:middle; }");
			sheet.addRule(".c-datepicker__main__pad:before,.c-datepicker__main__pad:after{ content:''; width:0px; height:100%; display:inline-block; vertical-align:middle; }");
		}
		
		define.init = function($element){
			var lang = $(document.documentElement).attr("lang");
			var transformProp = OH.transitionalStyleProperty("transform", "_");
			var transformOriginProp = OH.transitionalStyleProperty("transform-origin", "_");
			
			var $main = $element.find('.c-datepicker__main').eq(0);
			var $trigger = $element.find('.c-datepicker__trigger').eq(0);
			var $label = $trigger.find('.c-datepicker__trigger__label').eq(0);
			var $currentCalendar = null;
			var tasks = new Object();
			var labelTemplate = (function(){
				var lang = document.documentElement.getAttribute("lang") || "";
				// console.log(lang);
				switch(lang){
					case "en": return "M d, y";
					case "":
					case "ja": return "y年 m月 d日";
				}
				return "y.m.d";
			})();
			var monthLabels = ["Jan.","Feb.","Mar.","Apr.","May","Jun.","Jul.","Aug","Sep.","Oct.","Nov.", "Dec."];
			var availables = ($main.data("availables") || "").split(",");
			var yesterdayTime = new Date().getTime() - 24 * 60 * 60 * 1000;
			
			var holidays = OH.getHolidays();
			
			var isToday = function(date){
				var today = new Date();
				return date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate();
			};
			
			var textDate = function(date){
				var zeroPadding = function(num, length){
					return (new Array(length).join("0") + num).slice(-length);
				};
				return date.getFullYear() + "" + zeroPadding(date.getMonth() + 1, 2) + "" + zeroPadding(date.getDate(), 2);
			};
			
			var parseDate = function(strDate){
				return new Date(strDate.slice(0, 4) - 0, strDate.slice(4, 6) - 1, strDate.slice(6) - 0);
			};
			
			var todayText = (function(){
				var $todayLabel = $label.find('[data-label-today]');
				if(!$todayLabel || $todayLabel.length == 0){
					return "today";
				}
				return $label.find('[data-label-today]').eq(0).text();
			})();
			
			var setLabelText = function(date){
				$label.text(labelTemplate.replace("y", date.getFullYear()).replace("m", date.getMonth() + 1).replace("M", monthLabels[date.getMonth()]).replace("d", date.getDate()) + (isToday(date) ? ("（" + todayText + "）") : ""));
			};
			var setDate2main = function(date){
				setLabelText(date);
				$main.val(textDate(date));
				
				if(!!document.createEvent){
					var evt = document.createEvent("HTMLEvents");
					evt.initEvent("change", false, true);
					$main.get(0).dispatchEvent(evt);
				}
				else{
					$main.get(0).fireEvent("onchange");
				}
			};
			
			var monthTable = function(year, month){
				var days = (lang == "ja" || !lang) ? ["日","月","火","水","木","金","土"] : ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
				var startDate = new Date(year, month - 1, 1);
				var lastDate = new Date(year, month, 0);
				var dates = new Array().concat(emptyRange(startDate.getDay()), datesRange(lastDate.getDate()), emptyRange(6 - lastDate.getDay()));

				var table = document.createElement("table");
				$(table).append($("<thead>").append((function(){
					var $tr = $("<tr>");
					for(var i=0; i<days.length; i++){
						var type = i==0 ? "sun" : i==6 ? "sat" : "bsn";
						$tr.append($("<th>").text(days[i]).addClass("is-" + type));
					}
					return $tr;
				})())).addClass("c-datepicker__main__calendar");
				
				var tr = null;
				for(var i=0; i<dates.length; i++){
					(function(index, value){
						var type = index%7==0 ? "sun" : index%7==6 ? "sat" : "wek";
						if(i%7 == 0){
							tr = table.insertRow(-1);
						}
						var $cell = $(tr.insertCell(-1));
						if(!value){
							return;
						}
						var labelDate = new Date(year, month - 1, value - 0);
						var labelTextDate = textDate(labelDate);
						var available = availables.indexOf(labelTextDate) >= 0;
						var disabled = labelDate.getTime() <= yesterdayTime;
						
						if(holidays.indexOf(labelTextDate) >= 0){
							type = "sun";
						}
						$cell.addClass("is-" + type);
						
						var $label;
						if(!disabled){
							$label = $("<a>").attr("href", "#").text(value).on("click", function(event){
								event.preventDefault();
								setDate2main(new Date(year, month - 1, value - 0));
								tasks.removeCalendar(event);
							});
						}
						else{
							$label = $("<span>").text(value);
						}
						
						if(isToday(labelDate)){
							$cell.addClass("is-today");
						}
						
						if(disabled || !available){
							$cell.addClass("is-nomatch");
						}
						
						$cell.append($label);
						
					})(i, dates[i]);
				}
				return $(table);
			};
			
			var calendarGroup = function(year, month, type){
				var startDate = new Date(year, month - 1, 1);
				var $group = $("<div>").addClass("c-datepicker__main__group").css("box-sizing", "border-box");
				var $header = $("<div>").addClass("c-datepicker__main__header");
				
				var $siftTrigger;
				switch(type){
					case -1:
						$siftTrigger = $("<a>").attr("href", "#").addClass("c-datepicker__main__prev").append($("<span>").addClass("ui-icon").text("_")).on("click", function(event){
							event.preventDefault();
							event.stopPropagation();
							$siftTrigger.parents(".c-datepicker__main__panel").eq(0).css(transformProp, "translateX(0%)");
						});
					break;
					
					case  0:
						$siftTrigger = $("<span>").css("display", "none");
					break;
					
					case  1:
						$siftTrigger = $("<a>").attr("href", "#").addClass("c-datepicker__main__next").append($("<span>").addClass("ui-icon").text("_")).on("click", function(event){
							event.preventDefault();
							event.stopPropagation();
							$siftTrigger.parents(".c-datepicker__main__panel").eq(0).css(transformProp, "translateX(-100%)");
						});
					break;
					
					default: $siftTrigger = $("<span>").css("display", "none");
				}
				$siftTrigger.on("mousedown touchstart", function(event){
					event.stopPropagation();
				});
				$header.append($siftTrigger);
				
				var $title = $("<div>").addClass("c-datepicker__main__title").text(startDate.getFullYear() + "年 " + (startDate.getMonth() + 1) + "月");
				return $group.append($header.append($title)).append(monthTable(year, month));
			};
			
			
			var showFullCalendar = function(year, month){
				var $pad = $("<div>").css({
					position : "fixed",
					width : "100%",
					height : "100%",
					"background-color" : "rgba(0,0,0,0)",
					"z-index" : 999,
					top : "0px",
					left : "0px"
				});
				var $area = $("<div>").css({
					position : "relative",
					width : "100%",
					height : "1px",
					display : "block",
					"z-index" : 1000,
					"box-sizing" : "border-box"
				});
				var $board = $("<div>").css({
					position : "absolute",
					width : "100%",
					height : "auto",
					display : "block",
					overflow : "hidden",
					"box-sizing" : "border-box"
				});
				
				var nextMonth = new Date(year, month, 1);
				var $calendar = $("<div>").addClass("c-datepicker__main").css(transformOriginProp, "0px 0px").css({
					opacity : 0
				});
				var $thisMonth = calendarGroup(year, month).css("width", "50%");
				var $nextMonth = calendarGroup(year, month + 1).css("width", "50%");
				
				$area.append($board.append($calendar.append($thisMonth).append($nextMonth)));
				$element.append($area);
				
				var height = $calendar.get(0).clientHeight + parseInt($calendar.css("border-top-width")) + parseInt($calendar.css("border-bottom-width"));
				$board.css("height", height + "px");
				$calendar.css(transformProp, "translateY(-" + height + "px)").css("opacity", "");
				window.setTimeout(function(){
					$calendar.css("transition", transformProp + " 1ms linear").css(transformProp, "translateY(0px)");
				});
				
				$area.on("click", function(event){
					event.stopPropagation();
				});
				$currentCalendar = $area;
				$(document.body).append($pad);
			
				tasks.removeCalendar = function(){
					if(!!$currentCalendar){
						$currentCalendar.remove();
					}
					$currentCalendar = null;
					
					$pad.remove();
					
					$(window).off("resize", tasks.removeCalendar);
					$pad.off("click", tasks.removeCalendar);
				};
				
				$(window).on("resize", tasks.removeCalendar);
				$pad.on("click touchstart", tasks.removeCalendar);
			};
			
			var showNarrowCalendar = function(year, month){

				var $pad = $("<div>").css({
					position : "fixed",
					width : "100%",
					height : "100%",
					"background-color" : "rgba(0,0,0,0.5)",
					"z-index" : 999,
					top : "0px",
					left : "0px"
				}).addClass("c-datepicker__main__pad");
				
				
				var nextMonth = new Date(year, month, 1);
				
				var $wrap = $("<div>").addClass("c-datepicker__main").css({
					width : "300px",
					overflow : "hidden",
					"text-align" : "left"
				}).on("mousedown touchstart", function(event){
					event.stopPropagation();
				});
				var $calendar = $("<div>").addClass("c-datepicker__main__panel").css("transition", transformProp + " 300ms linear").css(transformProp, "translateX(0%)");
				var $thisMonth = calendarGroup(year, month, 1).css("width", "100%");
				var $nextMonth = calendarGroup(year, month + 1, -1).css("width", "100%");
				
				$pad.append($wrap.append($calendar.append($thisMonth).append($nextMonth)));
				
				$currentCalendar = $calendar;
				$(document.body).append($pad);
				
				var scale = ($pad.get(0).clientWidth - 30) / 300;
				$wrap.css(transformProp, "scale(" + scale + ")");
			
				tasks.removeCalendar = function(event){
					event.preventDefault();
					if(!!$currentCalendar){
						$currentCalendar.remove();
					}
					$currentCalendar = null;
					
					$pad.remove();
					
					$(window).off("resize", tasks.removeCalendar);
					$pad.off("mousedown touchstart", tasks.removeCalendar);
				};
				
				$(window).on("resize", tasks.removeCalendar);
				$pad.on("mousedown touchstart", tasks.removeCalendar);
			};
			
			$trigger.on("click", function(event){
				var today = new Date();
				if(!$currentCalendar){
					if(window.innerWidth > 768){
						showFullCalendar(today.getFullYear(), today.getMonth() + 1);
					}
					else{
						showNarrowCalendar(today.getFullYear(), today.getMonth() + 1);
					}
				}
			});
			
			setLabelText(!$main.val() ? new Date() : parseDate($main.val()));
		};
		
		return define;
	})();

})(jQuery);
